import { TInitialState } from '~/src/features/tariffBuilder/reducer';

const getPhone = (state: TInitialState) => {
    const { currentTariff, client } = state;
    if (currentTariff && client.contactPhone?.value !== -1) {
        return client.contactPhone?.label;
    }

    return client.phone;
};

export default getPhone;
